'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOrInviteUser = exports.getUser = exports.fetchUsers = exports.checkIdleUsers = exports.fetchUserActivity = exports.refreshMe = exports.updateMe = exports.fetchMe = undefined;

var _lodash = require('lodash');

var _http = require('../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _resources = require('../utils/services/http/resources');

var _resources2 = _interopRequireDefault(_resources);

var _userActions = require('./userActions');

var _userHelper = require('../../common/users/userHelper');

var _userUtil = require('./userUtil');

var _resourceUtil = require('../utils/services/http/resources/resourceUtil');

var _usersSelector = require('./usersSelector');

var _currentUserSelector = require('./currentUserSelector');

var _remoteUsersSelector = require('../utils/collaboration/remoteUsersSelector');

var _httpConstants = require('../../common/utils/http/httpConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Selectors


// Actions


// Utils
var fetchMe = exports.fetchMe = function fetchMe() {
    var timezone = new Date().getTimezoneOffset();
    return (0, _http2.default)({ url: 'users/me', timeout: 30000, retry: 1, params: { timezone: timezone } });
};

// Constants


// Utils
// Lib
var updateMe = exports.updateMe = function updateMe(_ref) {
    var userChanges = _ref.userChanges;
    return (0, _http2.default)({ url: 'users/me', method: _httpConstants.METHODS.PUT, timeout: 10000, retry: 1, data: { userChanges: userChanges } }).then(function (response) {
        return response.data;
    });
};

var refreshMe = exports.refreshMe = function refreshMe() {
    return (0, _http2.default)({ url: 'users/me/refresh', timeout: 10000 });
};

var userResourcesService = (0, _resources2.default)('users');

/**
 * Retrieves just the user activity details for the specified user IDs.
 */
var fetchUserActivity = exports.fetchUserActivity = function fetchUserActivity(userIds) {
    return function (dispatch, getState) {
        var state = getState();

        var isGuest = (0, _currentUserSelector.isGuestSelector)(state);
        if (isGuest) return;

        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);
        var userIdsToFetch = userIds.filter((0, _userHelper.isNotUserId)(currentUserId));

        if (!userIdsToFetch.length) return Promise.resolve();

        var usersActivityHttpConf = {
            url: 'users/activity',
            params: {
                ids: userIdsToFetch.join(',')
            }
        };

        // First retrieve the users' activity data
        return (0, _http2.default)(usersActivityHttpConf).then(function (response) {
            var users = response.data.users;

            var disconnectedUserIds = (0, _lodash.difference)(userIdsToFetch, (0, _lodash.keys)(users));
            dispatch((0, _userActions.userActivityLoad)({ users: users, disconnectedUserIds: disconnectedUserIds }));
            return response;
        }).catch(function (err) {
            dispatch((0, _userActions.userActivityError)(userIdsToFetch, err));
            return Promise.reject(err);
        });
    };
};

/**
 * Checks for all idle users and retrieves their updated activity information if any are found.
 */
var checkIdleUsers = exports.checkIdleUsers = function checkIdleUsers() {
    return function (dispatch, getState) {
        var state = getState();
        var idleUserIds = (0, _remoteUsersSelector.getIdleOnlineUserIds)(state);

        if (!idleUserIds.length) return;

        return dispatch(fetchUserActivity(idleUserIds));
    };
};

/**
 * Retrieves the user details as well as the user activity for the specified user IDs.
 */
var fetchUsers = exports.fetchUsers = function fetchUsers(userIds) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var state = getState();
        var userResources = (0, _usersSelector.userResourcesSelector)(state);
        var getUserResource = (0, _userUtil.getUserFn)(userResources);

        var isGuest = (0, _currentUserSelector.isGuestSelector)(state);
        if (isGuest) return;

        var missingUserIds = userIds.filter(_userHelper.isRealUserId).filter(function (userId) {
            return (0, _resourceUtil.shouldFetchResource)(force, getUserResource(userId));
        });

        if (!missingUserIds.length) {
            return;
        }

        dispatch(fetchUserActivity(missingUserIds));

        return userResourcesService({ dispatch: dispatch, config: { retry: 3 }, ids: missingUserIds }).then(function (response) {
            dispatch((0, _userActions.loadUsers)(response.data.users));
            return response;
        });
    };
};

var getUser = exports.getUser = function getUser(_ref2) {
    var userId = _ref2.userId,
        _ref2$force = _ref2.force,
        force = _ref2$force === undefined ? false : _ref2$force;
    return function (dispatch, getState) {
        if (!userId) {
            return Promise.reject('Must provide a user ID.');
        }

        // The public/guest/_other user ID is not a real user, so don't fetch it
        if (!(0, _userHelper.isRealUserId)(userId)) return;

        var state = getState();
        var users = state.get('users');
        var userResources = (0, _usersSelector.userResourcesSelector)(state);

        var userResource = userResources.get(userId);
        if (!(0, _resourceUtil.shouldFetchResource)(force, userResource)) {
            var user = users.get(userId);
            return Promise.resolve(user.toJS());
        }

        return userResourcesService({ dispatch: dispatch, id: userId }).then(function (response) {
            var userData = response.data.user;
            dispatch((0, _userActions.loadUser)(userData));
            return userData;
        });
    };
};

var getOrInviteUser = exports.getOrInviteUser = function getOrInviteUser(_ref3) {
    var userEmail = _ref3.userEmail;
    return function (dispatch, getState) {
        if (!userEmail) {
            return Promise.reject('Must provide a user email.');
        }

        var lowerCaseUserEmail = userEmail.toLowerCase();
        var state = getState();
        var users = state.get('users');

        var filteredUsers = users.filter(function (userEntry) {
            return userEntry.get('email') === lowerCaseUserEmail;
        });
        var user = filteredUsers.size ? filteredUsers.first() : null;

        if (user) return Promise.resolve(user.toJS());

        var userReq = {
            method: _httpConstants.METHODS.POST,
            url: 'users/get-or-invite',
            data: {
                email: lowerCaseUserEmail
            },
            retry: 3
        };

        return (0, _http2.default)(userReq).then(function (response) {
            var userData = response.data.user;
            dispatch((0, _userActions.loadUser)(userData));
            return userData;
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userService.js
// module id = 106
// module chunks = 0